import { render, staticRenderFns } from "./SurveyresultList.vue?vue&type=template&id=1581a5cc&scoped=true&"
import script from "./SurveyresultList.vue?vue&type=script&lang=js&"
export * from "./SurveyresultList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyresultList.vue?vue&type=style&index=0&id=1581a5cc&lang=scss&scoped=true&"
import style1 from "./SurveyresultList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1581a5cc",
  null
  
)

export default component.exports